import { render, staticRenderFns } from "./copyRight.vue?vue&type=template&id=7c86cdc8&scoped=true&"
import script from "./copyRight.vue?vue&type=script&lang=js&"
export * from "./copyRight.vue?vue&type=script&lang=js&"
import style0 from "./copyRight.vue?vue&type=style&index=0&id=7c86cdc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c86cdc8",
  null
  
)

component.options.__file = "copyRight.vue"
export default component.exports